import { Typography, Space, Divider, Flex } from "antd";
import { LLFormatWithTime } from "../../../shared/helpers/DateFunctions";
import { formatCurrency, FormatDateTimeFun } from "../../../shared";
import "./index.css";
import { useAppointment } from "../../../context/AppointmentContext";

const { Text, Title } = Typography;

const PayReceipt = ({ data }) => {
  const { paymentInfo, calculateTotalPrice, selectedServices } =
    useAppointment();

  if (!data) return null;
  const client = data.client || {};
  const services = data.services || [];
  const sessions = data.sessions || [];
  const payment = data.paymentInfo || [];
  // Helper to get service name by serviceId
  const getServiceName = (serviceId) => {
    const svc = services.find(
      (s) => s.serviceId === serviceId || s.id === serviceId,
    );
    return svc?.serviceName || svc?.name || svc?.shortName || "Service";
  };
  // const sessionRows = sessions.map((session) => {
  //   const serviceName = getServiceName(session.serviceId);
  //   const sessionDate = session.dateTime
  //     ? new Date(session.dateTime).toLocaleDateString("en-GB")
  //     : session.sessionDateTime
  //       ? new Date(session.sessionDateTime).toLocaleDateString("en-GB")
  //       : "—";
  //   const pricePerSession = session.price || 0;
  //   return {
  //     serviceName,
  //     sessionDate,
  //     price: pricePerSession,
  //     note: session.note || "",
  //     dateTime: sessionDate,
  //   };
  // });
  const sessionRows = sessions.map((session) => {
    const serviceName = getServiceName(session.serviceId);

    const rawDate = session.dateTime || session.sessionDateTime;

    const sessionDate = rawDate
      ? rawDate?.toDate
        ? rawDate.toDate() // Dayjs -> JS Date
        : new Date(rawDate)
      : null;

    return {
      serviceName,
      sessionDate,
      price: session.price || 0,
      note: session.note || "",
    };
  });

  if (sessionRows.length === 0) {
    sessionRows.push({
      serviceName: "No sessions booked",
      sessionDate: null,
      price: 0,
    });
  }

  const totalPayment = services.reduce((sum, s) => sum + (s.total || 0), 0);

  const totalAdvance = services.reduce((sum, s) => sum + (s.advance || 0), 0);

  const totalRemaining = services.reduce(
    (sum, s) => sum + (s.remaining || 0),
    0,
  );

  return (
    <div
      className="ultra-clean-receipt"
      style={{
        // padding: "24px",
        background: "#fff",
        maxWidth: "800px",
        margin: "0 auto",
      }}
    >
      <Space direction="vertical" style={{ width: "100%" }} size={0}>
        <div style={{ textAlign: "right" }}>
          <Text type="secondary" style={{ fontSize: 14 }}>
            <Text strong>Date: </Text>
            <Text>{LLFormatWithTime()}</Text>
          </Text>
        </div>

        <div style={{ fontSize: 15, lineHeight: "1.8" }}>
          <div>
            <Text strong>MRN: </Text>
            <Text>{client?.mrn || "-"}</Text>
          </div>
          <div>
            <Text strong>Name: </Text>
            <Text>{client.name || "-"}</Text>
          </div>
          <div>
            <Text strong>Age: </Text>
            <Text>{client.age || "-"}</Text>
          </div>
        </div>

        {/* ==================== MIDDLE SECTION: One Row Per Session ==================== */}
        {selectedServices?.map((service, index) => (
          <table
            className="clean-table"
            style={{
              width: "100%",
            }}
            key={"service-index" + index}
          >
            <thead style={{ backgroundColor: "#e0e0e0" }}>
              <tr>
                <th style={{ textAlign: "left", fontSize: 14, width: "10%" }}>
                  #
                </th>
                <th style={{ textAlign: "center", fontSize: 14, width: "45%" }}>
                  Date
                </th>
                <th style={{ textAlign: "right", fontSize: 14, width: "45%" }}>
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              {service?.sessions?.map((session, s) => (
                <tr key={"session-" + s} className="fs-13">
                  <td>{s + 1}</td>
                  <td style={{ textAlign: "center" }}>
                    {session?.dateTime
                      ? FormatDateTimeFun(session?.dateTime)
                      : "No date selected"}
                  </td>
                  <td style={{ textAlign: "right" }}>
                    {formatCurrency(session?.price)}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={4}>
                  <div
                    style={{ display: "flex", gap: 5, width: "100%" }}
                    className="fs-13"
                  >
                    <span style={{ fontWeight: 500 }}>
                      ({service?.serviceName}) -{" "}
                    </span>
                    <span>
                      <span style={{ fontWeight: 500 }}>Total Payment: </span>{" "}
                      {formatCurrency(service?.total)},
                    </span>
                    <span>
                      <span style={{ fontWeight: 500 }}> Advance: </span>{" "}
                      {formatCurrency(service?.advance)},
                    </span>
                    <span>
                      <span style={{ fontWeight: 500 }}> Balance: </span>{" "}
                      {formatCurrency(service?.remaining)}
                    </span>
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        ))}
        <table
          className="clean-table"
          style={{
            width: "100%",
          }}
        >
          <thead style={{ backgroundColor: "#e0e0e0" }}>
            <tr>
              <th style={{ textAlign: "left", fontSize: 14, width: "20%" }}>
                Total Payment
              </th>
              <th style={{ textAlign: "center", fontSize: 14, width: "20%" }}>
                Advance
              </th>
              <th style={{ textAlign: "right", fontSize: 14, width: "20%" }}>
                Balance
              </th>
            </tr>
          </thead>
          <tbody>
            {
              <tr className="fs-13">
                <td style={{ borderBottom: 0 }}>
                  {formatCurrency(totalPayment)}
                </td>
                <td style={{ textAlign: "center", borderBottom: 0 }}>
                  {formatCurrency(payment?.advancePayment)}
                </td>
                <td style={{ textAlign: "right", borderBottom: 0 }}>
                  {formatCurrency(payment?.duePayment)}
                </td>
              </tr>
            }
          </tbody>
        </table>
        <div>
          <Text strong>Note:</Text>
          <ul
            style={{
              margin: "5px 0 0 20px",
              padding: 0,
              color: "#595959",
            }}
            className="fs-13"
          >
            <li>Advance is not Refundable</li>
            <li>Be on Time</li>
          </ul>
        </div>

        <Flex justify="end">
          <Text italic className="fs-13">
            This is computer generated receipt no signature required.
          </Text>
        </Flex>
      </Space>
    </div>
  );
};

export default PayReceipt;
